import { render, staticRenderFns } from "./customAudience.vue?vue&type=template&id=12cde60f&scoped=true"
import script from "./customAudience.vue?vue&type=script&lang=js"
export * from "./customAudience.vue?vue&type=script&lang=js"
import style0 from "./customAudience.vue?vue&type=style&index=0&id=12cde60f&prod&lang=less&scoped=true"
import style1 from "./customAudience.vue?vue&type=style&index=1&id=12cde60f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_gliqtm7r2yknapxh4mg6r2qyi4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cde60f",
  null
  
)

export default component.exports